


import { useState, memo } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { injectRouter, IRouteName } from '../../interface/route';
import Controller from '../../controllers/floorplan';
import args from './arguments';
import { injectQueryURL } from '../../interface/util';
import { IFloorplanControllerProps } from '../../controllers/floorplan/interface';
import { injectConfigAPI } from '../../interface/config';

function FloorplanRoute(props: RouteComponentProps<{}>) : JSX.Element {
    const query = injectQueryURL();
    const router = injectRouter();
    const configAPI = injectConfigAPI();

    const [state, _] = useState<IFloorplanControllerProps>({
        route: args(props, query, configAPI),
        onRequestSiteObject: function(this: IFloorplanControllerProps, id: number) {
            router.push(IRouteName.SiteObject, props.history, {
                ...state.route,
                siteObjectId: id,
            });
        },
        onRequestBack: function(this: IFloorplanControllerProps) {
            props.history.goBack();
        },
    });

    return (
        <Controller.renderer 
            key="FloorplanRoute" 
            {...state}
        />
    )    
}

const propsEqual = (prev: RouteComponentProps<{}>, next: RouteComponentProps<{}>) => {
    return (
        ( prev.location.search === next.location.search ) &&
        ( prev.location.pathname === next.location.pathname )
    );
}

export default memo(FloorplanRoute, propsEqual);

